/*
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2022-11-18 17:17:23
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-12-07 10:24:08
 * @FilePath: \wanguo_web\common_web\src\api\general.js
 */

import request from '@/router/axios'


// 国家列表

export function getCuntList (query) {
  return request({
    url: '/api/blade-system/tenant/list/ext',
    method: 'get',
    params: query
  })
}

export function shopBuyMachinehourPage (query) {
  return request({
    url: '/api/shopBuyMachinehour/page',
    method: 'get',
    params: query
  })
}

export function shopBuyMachinehourdetail(query) {
  return request({
    url: `/api/shopBuyMachinehour/${query.id}`,
    method: 'get',
  
  })
}

// 装机总代审核

export function shopBuyMachinehourcheck (obj) {
  return request({
    url: '/api/shopBuyMachinehour/check',
    method: 'post',
    data: obj
  })
}
